import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import CancelButton from "../Buttons/CancelButton";
import InlineAlert from "../InlineAlert";
import ConfirmButton from "../Buttons/ConfirmButton";
import { useTranslation } from "react-i18next";

export default function ConfirmModal({
    isOpen,
    message,
    onClose,
    onConfirm,
    alert,
    loading,
    buttonsEnabled
}) {
    const { t } = useTranslation();

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className={`flex min-h-full items-center justify-center p-4 text-center ${loading && "cursor-wait opacity-25"}`}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full flex flex-col max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg leading-6 font-dosisbold"
                                >
                                    {t("confirmModalTitle")}
                                </Dialog.Title>
                                <p className="text-center my-2">{message}</p>
                                <InlineAlert alert={alert} visible={alert.type === "error" || alert.type === "success"} />
                                <div className="mt-2 flex flex-row ml-auto gap-x-3">
                                    <CancelButton onClick={onClose} enabled={buttonsEnabled} />
                                    <ConfirmButton onClick={onConfirm} enabled={buttonsEnabled} />
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
